module.exports = __webpack_public_path__ + "img/cashless.ccf7802a.png";